import resource from "@core/Util/resources";

function resolveOperatorByName(operatorName) {
    //https://datanext.atlassian.net/browse/DPN-3562
    //Default to 'equals'
    if(!operatorName) {
        operatorName = 'equals';
    }

    //For now, assume we always have a match
    return checkpointOperators
        .find(co => co.name === operatorName);
}

const checkpointOperators = [{
    name: 'equals',
    get label() {
        return resource('JourneyComposerCheckpointOperator_Equals_DisplayName');
    }
}, {
    name: 'notEquals',
    get label() {
        return resource('JourneyComposerCheckpointOperator_NotEquals_DisplayName');
    }
}];

export {
    resolveOperatorByName,

    checkpointOperators
}